module.exports = __webpack_public_path__ + "static/CoreCrawler-520a09ce9b8340cb9b11dfb7e9126aa4.gif";